import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useContent } from "@/context/ContentContext";
import { renderLinkedText } from "@/lib/content";

export const FAQ = () => {
  const { content } = useContent();
  const faq = content.faq;
  return (
  <section
    id="faq"
    className="mx-auto max-w-4xl px-6 py-28 lg:py-40"
    data-testid="faq-section"
  >
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-100px" }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
      className="mb-16 text-left"
    >
      <p className="mb-6 text-[11px] font-bold uppercase tracking-[0.3em] text-[#7A2B21]">
        {faq.kicker}
      </p>
      <h2 className="font-display text-4xl font-medium leading-[1.1] tracking-tight text-[#1C1917] sm:text-5xl">
        {faq.title_line1}{" "}
        <span className="italic text-[#7A2B21]">{faq.title_line2}</span>
      </h2>
    </motion.div>

    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.9, delay: 0.1 }}
    >
      <Accordion type="single" collapsible className="w-full">
        {faq.items.map((f, i) => (
          <AccordionItem
            key={f.q}
            value={`item-${i}`}
            className="border-b border-[#1C1917]/10"
            data-testid={`faq-item-${i}`}
          >
            <AccordionTrigger
              className="py-6 text-left font-display text-lg font-medium tracking-tight text-[#1C1917] hover:text-[#7A2B21] hover:no-underline md:text-xl"
              data-testid={`faq-trigger-${i}`}
            >
              {renderLinkedText(f.q)}
            </AccordionTrigger>
            <AccordionContent
              className="pb-6 text-sm leading-relaxed text-[#57534E]"
              data-testid={`faq-content-${i}`}
            >
              {renderLinkedText(f.a)}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </motion.div>
  </section>
  );
};
